import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { MailConfigurationContent } from '@/pages/mailConfiguration/components/MailConfigurationContent';

const MailConfiguration: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Mailkonfiguration | Starjack Admin</title>
            </Helmet>

            <MailConfigurationContent />
        </>
    );
};

MailConfiguration.isProtected = true;
MailConfiguration.getLayout = (Component) => (
    <SidebarLayout>{Component}</SidebarLayout>
);
MailConfiguration.permissions = [Permission.MAIL_CONFIGURATION_NAV];

export default MailConfiguration;
